import React from 'react';

import { View } from 'react-native-web';
import { Box } from '@styleseat/ui';
import AccountMenu from '../AccountMenu';
import { HeaderLinks } from '../HeaderLinks';
import ProHeaderDropdown from '../../../provider/navigation/ProHeaderDropdown';
import './HeaderMenu.module.scss';

const HeaderMenu = ({
  providerId,
  referralEntry,
  showReferralEntry,
  isLandingRedesignEnabled = false,
  isMobile = false,
}: {
  providerId?: number;
  referralEntry?: React.JSX.Element;
  showReferralEntry?: boolean;
  isLandingRedesignEnabled?: boolean;
  isMobile?: boolean;
}) => {
  if (isMobile && isLandingRedesignEnabled) {
    return isLandingRedesignEnabled ? null : (<div />);
  }

  return (
    <View styleName="headerMenu" testID="header-menu-options-container">
      <AccountMenu isLandingRedesignEnabled={isLandingRedesignEnabled} />
      <HeaderLinks />
      {providerId ? (
        <View
          styleName="proMenu"
          style={{
            marginRight: isLandingRedesignEnabled ? 0 : 20,
          }}
        >
          <ProHeaderDropdown
            providerId={providerId}
            isLandingRedesignEnabled={isLandingRedesignEnabled}
          />
        </View>
      ) : null}
      {showReferralEntry && !isLandingRedesignEnabled && (
        <Box paddingRight={24} paddingTop={28}>
          {referralEntry}
        </Box>
      )}
    </View>
  );
};

export default HeaderMenu;
